import dAPI from './dapi';

const Auth = {
    login: ( data, options ) => {
        return dAPI.post( '/auth/login', data, options );
    },
};

export default Auth;
